import React, { useState } from "react";


const Form = ({ styles, detail, onSubmit }) => {

    const [state, setState] = useState({

        company_name: {
            name: "company_name",
            value: detail ? detail.COMPANY_NAME : "",
            error: "",
            isRequired: true
        },

        industry: {
            name: "industry",
            value: detail ? detail.INDUSTRY : "",
            error: "",
            isRequired: false
        },

        website: {
            name: "website",
            value: detail ? detail.WEBSITE : "",
            error: "",
            isRequired: false
        },

        contact_person: {
            name: "contact_person",
            value: detail ? detail.CONTACT_PERSON : "",
            error: "",
            isRequired: true
        },

        designation: {
            name: "designation",
            value: detail ? detail.DESIGNATION : "",
            error: "",
            isRequired: false
        },

        email: {
            name: "email",
            value: detail ? detail.EMAIL : "",
            error: "",
            isRequired: true
        },

        phone: {
            name: "phone",
            value: detail ? detail.PHONE : "",
            error: "",
            isRequired: true
        },

        jobs: [
            {
                job_role: "",
                vacancies: "",
                job_type: "JOB",
                job_location: "",
                salary_range: "",
                stipend: ""
            }
        ]

    });



    const handleChange = (e) => {
        const { name, value } = e.target;

        setState(prev => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: value
            }
        }))
    };



    const handleJobChange = (index, field, value) => {

        const updated = [...state.jobs];

        updated[index][field] = value;

        setState(prev => ({
            ...prev,
            jobs: updated
        }));

    };



    const addJob = () => {

        setState(prev => ({
            ...prev,
            jobs: [
                ...prev.jobs,
                {
                    job_role: "",
                    vacancies: "",
                    job_type: "JOB",
                    job_location: "",
                    salary_range: "",
                    stipend: ""
                }
            ]
        }));

    };



    const removeJob = (index) => {

        const updated = [...state.jobs];
        updated.splice(index, 1);

        setState(prev => ({
            ...prev,
            jobs: updated
        }));

    };



    const handleSubmit = () => {

        const payload = {
            company_name: state.company_name.value,
            industry: state.industry.value,
            website: state.website.value,
            contact_person: state.contact_person.value,
            designation: state.designation.value,
            email: state.email.value,
            phone: state.phone.value,
            jobs: state.jobs
        };

        onSubmit(payload);

    };



    return (

        <>

            {/* COMPANY DETAILS */}

            <div className="card border-0 shadow-sm rounded-3 mb-3">
                <div className={`${styles['bgblue-ctm']} text-white`}>
                    <h5>Company Details</h5>
                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-6 mb-3">
                            <label>Company Name *</label>
                            <input
                                className="form-control"
                                name="company_name"
                                value={state.company_name.value}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label>Industry</label>
                            <input
                                className="form-control"
                                name="industry"
                                value={state.industry.value}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label>Company Website</label>
                            <input
                                className="form-control"
                                name="website"
                                value={state.website.value}
                                onChange={handleChange}
                            />
                        </div>

                    </div>
                </div>
            </div>



            {/* CONTACT PERSON */}

            <div className="card border-0 shadow-sm rounded-3 mb-3">
                <div className={`${styles['bgblue-ctm']} text-white`}>
                    <h5>Contact Person</h5>
                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-6 mb-3">
                            <label>Contact Person *</label>
                            <input
                                className="form-control"
                                name="contact_person"
                                value={state.contact_person.value}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label>Designation</label>
                            <input
                                className="form-control"
                                name="designation"
                                value={state.designation.value}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label>Email *</label>
                            <input
                                className="form-control"
                                name="email"
                                value={state.email.value}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label>Mobile *</label>
                            <input
                                className="form-control"
                                name="phone"
                                value={state.phone.value}
                                onChange={handleChange}
                            />
                        </div>

                    </div>
                </div>
            </div>



            {/* JOB OPENINGS */}

            <div className="card border-0 shadow-sm rounded-3 mb-3">

                <div className={`${styles['bgblue-ctm']} text-white d-flex justify-content-between align-items-center`}>
                    <h5 className="mb-0">Job Openings</h5>

                    <button
                        type="button"
                        className="btn btn-light btn-sm"
                        onClick={addJob}
                    >
                        + Add Job
                    </button>

                </div>

                <div className="card-body">

                    {state.jobs.map((job, index) => (
                        <div key={index} className="border p-3 mb-3 rounded">

                            <div className="row">

                                <div className="col-md-4 mb-3">
                                    <label>Job Role *</label>
                                    <input
                                        className="form-control"
                                        value={job.job_role}
                                        onChange={(e) => handleJobChange(index, 'job_role', e.target.value)}
                                    />
                                </div>

                                <div className="col-md-2 mb-3">
                                    <label>Vacancies *</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={job.vacancies}
                                        onChange={(e) => handleJobChange(index, 'vacancies', e.target.value)}
                                    />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label>Job Type</label>
                                    <select
                                        className="form-control"
                                        value={job.job_type}
                                        onChange={(e) => handleJobChange(index, 'job_type', e.target.value)}
                                    >
                                        <option value="JOB">Job</option>
                                        <option value="INTERNSHIP">Internship</option>
                                    </select>
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label>Location</label>
                                    <input
                                        className="form-control"
                                        value={job.job_location}
                                        onChange={(e) => handleJobChange(index, 'job_location', e.target.value)}
                                    />
                                </div>

                                {job.job_type == 'JOB' && <div className="col-md-4 mb-3">
                                    <label>Salary Range</label>
                                    <input
                                        type="number"

                                        className="form-control"
                                        value={job.salary_range}
                                        onChange={(e) => handleJobChange(index, 'salary_range', e.target.value)}
                                    />
                                </div>}

                                {job.job_type == 'INTERNSHIP' && <div className="col-md-4 mb-3">
                                    <label>Internship Stipend</label>
                                    <input
                                        type="number"

                                        className="form-control"
                                        value={job.stipend}
                                        onChange={(e) => handleJobChange(index, 'stipend', e.target.value)}
                                    />
                                </div>
                                }
                                <div className="col-md-4 d-flex align-items-end mb-3">

                                    {state.jobs.length > 1 && (
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => removeJob(index)}
                                        >
                                            Remove
                                        </button>
                                    )}

                                </div>

                            </div>

                        </div>
                    ))}

                </div>
            </div>



            <div className="text-end">
                <button
                    className={`${styles['btn-next']} btn`}
                    onClick={handleSubmit}
                >
                    Submit
                </button>
            </div>

        </>

    )

}

export default Form;